import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class EntitiesService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getEntitiesByCnpjRazaoSocial(cnpjAndRazaoSocial: string, ) {
    return this.http.get(
      this.baseUrl +
      `/v1/company?cnpjAndRazaoSocial=${cnpjAndRazaoSocial}
      `
    );
  }
  public registerEntitie(formData: any) {
    return this.http.post(`${this.baseUrl}/v1/entity`, { ...formData })
  }
  getEntitie(EntitieId: string) {
    return this.http.get(this.baseUrl + `/v1/company/${EntitieId}`);
  }
  getHistoryEntitie(EntitieId: string | null, pageIndex:number = 0) {
    return this.http.get(this.baseUrl + `/v1/company/${EntitieId}/history?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`);
  }
  getHistoryEndereco(adressId: string | null, pageIndex:number = 0) {
    return this.http.get(this.baseUrl + `/v1/enderecos/${adressId}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`);
  }
  getHistoryDadosBancarios(dataId: string | null, pageIndex:number = 0) {
    return this.http.get(this.baseUrl + `/v1/dados-bancarios/${dataId}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`);
  }
  deleteEntity(companyId: string | null) {
    return this.http.delete(this.baseUrl + `/v1/company/${companyId}`);
  }

  editEntitie(companyId: string | null, entitieData: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.patch(this.baseUrl + '/v1/entity', entitieData, { headers });

  }
  getEntities(
    pageIndex?: number,
    sortDirection?: string,
    sortProperty?: string,
    tipoEntidade?: string,
    razaoSocial?: string,
    nomeConcessao?: string,
    statusFilter?: string,
    cpnj?: string,
    cep?: string,
    cpf?: string,
    nomeRepresentante?: string,
    emailEntidade?: string,
  ): Observable<string[]> {
    const params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', '10')
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('tipoEntidade', tipoEntidade || '')
      .set('razaoSocial', razaoSocial || '')
      .set('nomeConcessao', nomeConcessao || '')
      .set('status', statusFilter || '')
      .set('cnpj', cpnj || '')
      .set('cep', cep || '')
      .set('cpfRepresentante', cpf || '')
      .set('nomeRepresentante', nomeRepresentante || '')
      .set('emailEntidade', emailEntidade || '');

    return this.http.get<any[]>(this.baseUrl + `/v1/company`, { params });
  }
  getEntitiesTypes() {
    return this.http.get(this.baseUrl + `/v1/type-companie`);
  }

  getEntityWithLinkedData(EntitieId: string) {
    return this.http.get(this.baseUrl + `/v1/company/${EntitieId}/users`);
  }

  linkUsersToEntity(data: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.patch(this.baseUrl + '/v1/company/update/users', data, {
      headers,
    });
  }
  

  linkConsorciosToEntity(data: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.patch(
      this.baseUrl + '/v1/company/update/consortium',
      data,
      {
        headers,
      }
    );
  }
  getEntitiesByResponsavel(
    pageIndex: number,
    sortDirection: string,
    sortProperty: string,
    cpf: string,
    nomeCompleto: string,
    funcao: string,
    email: string,
    cpnj: string
  ) {
    return this.http.get(
      this.baseUrl +
      `v1/representantive-legal?cpf=${cpf}&nomeCompleto=${nomeCompleto}&funcao=${funcao}&email=${email}`
    );
  }

  activate(companyId: number) {
    return this.http.patch(this.baseUrl + `/v1/company/${companyId}/active`, {});
  }

  inactivate(companyId: number) {
    return this.http.patch(this.baseUrl + `/v1/company/${companyId}/inactive`, {});
  }

  vinculateEntiteConcession(companyId: string, data: any) {

    const object = {
      unidadeAdministrrativa: data[0].concessoes[0].id
    }

    // Construir a URL
    const url = `${this.baseUrl}/v1/company/${companyId}/concession`;

    // Fazer a requisição HTTP
    return this.http.post(url, object);

  }

  getEntitieConcessionVinculated(
    companyId: string, 
    sortDirection?: string,
    sortProperty?: string, 
    cnpj?: string, 
    razaoSocial?: string, 
    cnpjOrRazaoSocial?: string
  ) {
    // Construir a URL base
    let url = `${this.baseUrl}/v1/company/${companyId}/concessionare`;
  
    // Inicializar um array de parâmetros
    const params: string[] = [];
  
    // Adicionar parâmetros opcionais ao array
    if (sortDirection) {
      params.push(`sortDirection=${sortDirection}`);
    }
    if (sortProperty) {
      params.push(`sortProperty=${sortProperty}`);
    }
    if (cnpj) {
      params.push(`cnpj=${cnpj}`);
    }
    if (razaoSocial) {
      params.push(`razaoSocial=${razaoSocial}`);
    }
    if (cnpjOrRazaoSocial) {
      params.push(`cnpjOrRazaoSocial=${cnpjOrRazaoSocial}`);
    }
  
    // Se houver parâmetros, adicioná-los à URL
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
  
    // Fazer a requisição HTTP
    return this.http.get(url);
  }
  

  getConcessionDisponivel(companyId: string) {
    const apiUrl = `${this.baseUrl}/v1/company?tipoEntidade=Concessionaria&status=true`;
    return this.http.get(apiUrl);

  }

  removeVinculoConcession(companyId: any, data: any) {
    // Construir a URL
    const url = `${this.baseUrl}/v1/company/${companyId}/concession`;


    // Fazer a requisição HTTP
    return this.http.delete(url, { body: data });

  }
}
